module.exports = __webpack_public_path__ + "img/sq6m_banner.5ddd3b5d.jpg";